import $ from 'jquery';

function openMailingPopup(e) {
	if (e) {
		e.preventDefault();
	}
	$.fancybox.open($("#mailing-popup"));
}

function mailingSubscribeSuccess() {
	$("#mailing-popup .mailingPopupSubscribe").hide();
	$("#mailing-popup .mailingPopupThanks").show();
	setTimeout(function() {
		$.fancybox.close();
	}, 2000);
}

function initMailingForm() {
	$("#mailing-popup form").on("submit", function(e) {
		e.preventDefault();

		var $div = $("#lockScreenDiv");
		if ($div.length === 0) {
			$div = $("<div/>").attr("id", "lockScreenDiv");
			$("body").append($div);
		}
		$div.show();
		$.ajax({
			url : '/ajax.php',
			data : $(this).serialize()
		}).always(function() {
			$div.hide();
		}).fail(function(jqXHR, textStatus, errorThrown) {
			if (jqXHR.responseJSON && jqXHR.responseJSON.error) {
				alert(jqXHR.responseJSON.error);
			} else {
				alert(textStatus + ": " + errorThrown);
			}
		}).done(mailingSubscribeSuccess);
	});
}

function getMailingPopupDelay() {
	const loc = window.location;
	if (loc.search.indexOf("mailing-popup") !== -1) {
		return 1;
	}
	if (document.cookie.indexOf("mailing-popup-seen") !== -1) {
		return -1;
	}
	if (loc.pathname === '/inschrijven') {
		return -1;
	}
	return 5000;
}

export function initMailingPopup() {
	$(".mailingButton").on("click", openMailingPopup);

	const mailingPopupDelay = getMailingPopupDelay();
	if (mailingPopupDelay > 0) {
		setTimeout(function() {
			openMailingPopup();
			const maxAge = 30 * 24 * 3600;
			document.cookie = 'mailing-popup-seen=1; path=/; Max-Age=' + maxAge + '; Secure';
		}, mailingPopupDelay);
	}

	initMailingForm();
}
